module.exports = __webpack_public_path__ + "static/meeting-room-c0627d02712db155a0ddfb08bdc94379.jpg";